import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationCreateSavedDocumentTextRatingArgs,
  BackendSavedDocumentTextRating,
} from 'src/types/backend';

const MUTATION = gql`
  mutation CreateSavedDocumentTextRating(
    $projectId: ID!
    $anchor: SavedDocumentAnchorInput!
    $value: SavedDocumentRatingEnum!
  ) {
    createSavedDocumentTextRating(projectId: $projectId, anchor: $anchor, value: $value) {
      id
    }
  }
`;

type Variables = BackendMutationCreateSavedDocumentTextRatingArgs;
type Result = Pick<BackendSavedDocumentTextRating, 'id'>;

export const createSavedDocumentTextRating = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
